<template>
  <div id="globalfn"></div>
</template>

<script>
import DataSource from '../data/datasource'

export default {
  name: 'GlobalFn',
  SortObjectByKey: function (object, key, type) {
    try {
      if (type.toLowerCase() === 'asc') {
        object = object.sort((a, b) => {
          // console.log(a[this.name1], b[this.name1]);
          return b[key] > a[key] ? -1 : b[key] < a[key] ? 1 : 0
          // return b[this.name1] - a[this.name1];
        })
      } else {
        object = object.sort((a, b) => {
          return b[key] < a[key] ? -1 : b[key] > a[key] ? 1 : 0
        })
      }

      return object
    } catch (err) {
      console.error(err)
    }
  },
  WhiteListExt: function (ext) {
    /*
            //Value return ['VIDEOS', 'AUDIO', 'IMAGES', 'FILES','ZIP']
            */

    return new Promise((resolve, reject) => {
      try {
        const response = DataSource.shared.getWhitelist()

        if (response.code === '88') {
          resolve('Error')
        } else if (response.code === '99') {
          resolve('Error')
        } else {
          Promise.all([response]).then(responseValue => {
            let result = 'Error'

            responseValue[0].Table.forEach(m => {
              if (m.ext.toUpperCase() === ext.toUpperCase()) {
                result = m.type
              }
            })

            resolve(result)
          })
        }
      } catch (e) {
        reject(e)
      }
    })
  },
  FileType: function (pExt) {
    try {
      let ext = pExt.toUpperCase()
      let result = 'ERROR'

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.JPEG':
        case '.BMP':
        case '.GIF':
          result = 'IMAGE'
          break
        case '.MP4':
          result = 'VIDEO'
          break
        case '.MP3':
        case '.AAC':
        case '.WAV':
          result = 'AUDIO'
          break
        case '.PDF':
          result = 'PDF'
          break
        case '.ZIP':
          result = 'ZIP'
          break
      }

      return result
    } catch (e) {
      console.log(e, 'FileType')
    }
  },
}
</script>

<style scoped></style>
